import React from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { MARKETING_TABS, marketingTabIndexByPath } from "./analyticsTabs";

const PURPLE = "#7c3aed";

// Top tab bar for Analytics > Marketing (Overview, Competitors), styled like the Analytics Reports tabs.
export default function MarketingLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeIndex = marketingTabIndexByPath(location.pathname);

  return (
    <Box>
      <Paper
        sx={{
          mb: 2,
          borderRadius: 3,
          border: "1px solid #eef0f4",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeIndex}
          onChange={(_, idx) => navigate(MARKETING_TABS[idx].path)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Marketing sections"
          sx={{
            minHeight: 48,
            px: { xs: 0.5, sm: 1 },
            bgcolor: "#fafafa",
            borderBottom: "1px solid #eef0f4",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "0.8rem", sm: "0.875rem" },
              minHeight: 48,
              color: "#64748b",
            },
            "& .Mui-selected": { color: PURPLE },
            "& .MuiTabs-indicator": { backgroundColor: PURPLE, height: 3 },
          }}
        >
          {MARKETING_TABS.map((tab) => (
            <Tab key={tab.slug} label={tab.label} />
          ))}
        </Tabs>
      </Paper>

      <Outlet />
    </Box>
  );
}
